<mat-toolbar>
    <div class="row" style="flex: 1; display: flex; gap: 4px">
        <ng-content select="[left-content]"></ng-content>
        @if (centerContentChild()) {
        <div class="center-content">
            <ng-container *ngTemplateOutlet="centerContentChild()"></ng-container>
        </div>
        } 
        @if (rightContentChild()) {
        <div class="right-content">
            <ng-container *ngTemplateOutlet="rightContentChild()"></ng-container>
        </div>
        }
    </div>
</mat-toolbar>
<mat-divider></mat-divider>